import { jsPDF } from "jspdf";

const MAX_EDGE = 1600;
const JPEG_QUALITY = 0.72;
const MAX_BYTES = 10 * 1024 * 1024;

function loadBitmap(file) {
  if (typeof createImageBitmap === "function") {
    return createImageBitmap(file, { imageOrientation: "from-image" }).catch(() => createImageBitmap(file));
  }
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("No se pudo leer la foto"));
    };
    img.src = url;
  });
}

function drawJpeg(source, maxEdge, quality) {
  const width = source.width || source.naturalWidth;
  const height = source.height || source.naturalHeight;
  if (!width || !height) throw new Error("La foto no tiene tamaño válido");
  const scale = Math.min(1, maxEdge / Math.max(width, height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(width * scale));
  canvas.height = Math.max(1, Math.round(height * scale));
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(source, 0, 0, canvas.width, canvas.height);
  const dataUrl = canvas.toDataURL("image/jpeg", quality);
  return { dataUrl, width: canvas.width, height: canvas.height };
}

function buildPdf(pages) {
  const doc = new jsPDF({ unit: "mm", format: "a4", compress: true });
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const margin = 8;
  pages.forEach((page, index) => {
    if (index > 0) doc.addPage();
    const maxW = pageW - margin * 2;
    const maxH = pageH - margin * 2;
    const ratio = Math.min(maxW / page.width, maxH / page.height);
    const w = page.width * ratio;
    const h = page.height * ratio;
    const x = (pageW - w) / 2;
    const y = (pageH - h) / 2;
    doc.addImage(page.dataUrl, "JPEG", x, y, w, h, undefined, "FAST");
  });
  const blob = doc.output("blob");
  return new File([blob], `reporte-${Date.now()}.pdf`, { type: "application/pdf" });
}

export async function photosToPdf(files) {
  if (!files.length) throw new Error("Toma al menos una foto");
  const sources = [];
  try {
    for (const file of files) {
      sources.push(await loadBitmap(file));
    }
    const attempts = [
      { edge: MAX_EDGE, quality: JPEG_QUALITY },
      { edge: 1200, quality: 0.6 },
      { edge: 900, quality: 0.5 },
    ];
    let pdf = null;
    for (const attempt of attempts) {
      const pages = sources.map((source) => drawJpeg(source, attempt.edge, attempt.quality));
      pdf = buildPdf(pages);
      if (pdf.size <= MAX_BYTES) return pdf;
    }
    throw new Error("Las fotos pesan demasiado. Quita alguna e inténtalo de nuevo.");
  } finally {
    sources.forEach((source) => {
      if (typeof source.close === "function") source.close();
    });
  }
}
